<template lang="pug">
DropdownCheckboxes(
  :label="label"
  :name="name"
  :options="sectionOptions"
  :value="value"
  @input="update"
  :loading="loading"
)
</template>

<script>
  import DropdownCheckboxes from '@/components/dropdown_checkboxes.vue'
  import { mapStores } from 'pinia'
  import { useSectionsStore } from '@/stores/sections'

  export default {
    components: {
      DropdownCheckboxes
    },

    props: {
      label: {
        type: String,
        default() { return 'Section' }
      },

      name: {
        type: String,
        default() { return 'q[story_sections_section_id_in][]' }
      },

      value: {
        type: Array,
        default() { return [] }
      }
    },

    computed: {
      ...mapStores(useSectionsStore),

      sectionOptions() {
        return this.sectionsStore.enabledAsObject
      },

      loading() {
        return this.sectionsStore.all.length === 0
      }
    },

    mounted() {
      this.sectionsStore.fetch()
    },

    methods: {
      update(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
